import { StyleSheet, View } from 'react-native';

import { IconChevronRight, Text, tokens } from '@fhs/ui';
import Link from '@fhs-legacy/frontend/src/components/link';
import { useGetMaybeCcpaLinkProps } from '@fhs-legacy/frontend/src/hooks/one-trust/use-get-maybe-ccpa-link-props';
import { isExternalLink } from '@fhs-legacy/frontend/src/utils/is-external-link';

import type { MoreLink } from './more-navigation';

function MoreLinkRow({ link, last }: { link: MoreLink; last: boolean }) {
  const getMaybeCcpaLinkProps = useGetMaybeCcpaLinkProps();
  const resolvedLinkProps = getMaybeCcpaLinkProps({
    to: { pathname: link.path, params: link.params },
    isExternal: isExternalLink(link.path),
    onPress: link.onPress,
    children: link.label,
  });
  const displayLabel =
    typeof resolvedLinkProps.children === 'string' ? resolvedLinkProps.children : link.label;

  return (
    <Link
      {...resolvedLinkProps}
      accessibilityRole="button"
      accessibilityLabel={displayLabel}
      dd-action-name={displayLabel}
    >
      <View style={[styles.row, last && styles.lastRow]}>
        <Text.Ui size="md" style={styles.rowLabel}>
          {displayLabel}
        </Text.Ui>
        <IconChevronRight size={20} color={tokens.colors.$houseDark} aria-hidden />
      </View>
    </Link>
  );
}

export function MoreLinkCard({ links }: { links: readonly MoreLink[] }) {
  return (
    <View style={styles.card}>
      {links.map((link, index) => (
        <MoreLinkRow key={link.label} link={link} last={index === links.length - 1} />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: tokens.colors.$white,
    borderColor: tokens.colors.$blackOpacity10,
    borderRadius: 8,
    borderWidth: 1,
    overflow: 'hidden',
  },
  row: {
    alignItems: 'center',
    borderBottomColor: tokens.colors.$blackOpacity04,
    borderBottomWidth: 1,
    flexDirection: 'row',
    gap: 16,
    minHeight: 56,
    paddingHorizontal: 16,
    paddingVertical: 10,
    width: '100%',
  },
  lastRow: { borderBottomWidth: 0 },
  rowLabel: { flex: 1, flexShrink: 1 },
});
